import React from 'react';

const Settings = () => {
    return (
        <div className="settings-container">
            <h1>Settings</h1>
            <p>Manage your settings here.</p>
        </div>
    );
};

export default Settings;
